var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.74958 16.5H15.244C15.4563 16.5 15.6354 16.5715 15.7812 16.7144C15.9271 16.8573 16 17.0344 16 17.2456C16 17.4569 15.9282 17.6354 15.7846 17.7812C15.6408 17.9271 15.4628 18 15.2504 18H4.75604C4.54368 18 4.36458 17.9285 4.21875 17.7856C4.07292 17.6427 4 17.4656 4 17.2544C4 17.0431 4.07181 16.8646 4.21542 16.7188C4.35917 16.5729 4.53722 16.5 4.74958 16.5ZM9.99792 14.5208C9.88819 14.5208 9.78201 14.4965 9.67937 14.4479C9.57674 14.3993 9.48917 14.3264 9.41667 14.2292L5.5 9.20833C5.30556 8.95833 5.27431 8.69444 5.40625 8.41667C5.53819 8.13889 5.76389 8 6.08333 8H7.5V2.75C7.5 2.5375 7.57188 2.35937 7.71563 2.21562C7.85938 2.07187 8.0375 2 8.25 2H11.75C11.9625 2 12.1406 2.07187 12.2844 2.21562C12.4281 2.35937 12.5 2.5375 12.5 2.75V8H13.9167C14.2361 8 14.4618 8.13889 14.5938 8.41667C14.7257 8.69444 14.6944 8.95833 14.5 9.20833L10.5833 14.2292C10.5101 14.3264 10.4217 14.3993 10.3181 14.4479C10.2144 14.4965 10.1076 14.5208 9.99792 14.5208Z",
    fill: "#252153"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.c0df014d3662bcd53344ccac10b34ea1.svg";
export { ForwardRef as ReactComponent };